// extracted by mini-css-extract-plugin
export default {"picRow":"Collection_picRow__+xpm8","nftsContainer":"Collection_nftsContainer__l3kgg"};